/* KO Reps theme JS: cart drawer (AJAX), product variant picker, tabs, thumbnails, toast */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }
  function on(id, ev, fn) { var el = $(id); if (el) el.addEventListener(ev, fn); }

  var toastT;
  function toast(msg) {
    var t = $('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 2200);
  }

  /* ---------- cart drawer ---------- */
  function openCart() {
    var d = $('drawer'), s = $('scrim');
    if (d) d.classList.add('open');
    if (s) s.classList.add('on');
  }
  function closeCart() {
    var d = $('drawer'), s = $('scrim');
    if (d) d.classList.remove('open');
    if (s) s.classList.remove('on');
  }
  on('cartOpen', 'click', function () { refreshCart().then(openCart); });
  on('cartClose', 'click', closeCart);
  on('scrim', 'click', closeCart);

  function money(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }

  function renderCart(cart) {
    var count = $('cartCount');
    if (count) count.textContent = cart.item_count;
    var total = $('cartTotal');
    if (total) total.textContent = money(cart.total_price);
    var box = $('cartItems');
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<p class="empty">Your cart is empty.</p>';
      return;
    }
    box.innerHTML = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' / ');
      return '<div class="citem">' +
        '<img src="' + it.image + '" alt="">' +
        '<div><h4>' + it.product_title + '</h4>' +
        '<div class="meta">' + (opts ? opts + ' &bull; ' : '') + 'Qty ' + it.quantity + '</div>' +
        '<button class="rm" data-line="' + (i + 1) + '">Remove</button></div>' +
        '<div><b>' + money(it.line_price) + '</b>' +
        '<div class="qty"><button data-ch="' + (i + 1) + '|-1">&minus;</button><span>' + it.quantity + '</span><button data-ch="' + (i + 1) + '|1">+</button></div></div>' +
        '</div>';
    }).join('');
    box.querySelectorAll('[data-ch]').forEach(function (b) {
      b.addEventListener('click', function () {
        var parts = b.getAttribute('data-ch').split('|');
        changeLine(parseInt(parts[0], 10), parts[1]);
      });
    });
    box.querySelectorAll('.rm').forEach(function (b) {
      b.addEventListener('click', function () {
        changeLine(parseInt(b.getAttribute('data-line'), 10), 'set0');
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(line, how) {
    var body = 'line=' + line;
    if (how === 'set0') {
      body += '&quantity=0';
    } else {
      var cur = 0;
      var btn = document.querySelector('[data-ch="' + line + '|' + how + '"]');
      if (btn) {
        var span = btn.parentNode.querySelector('span');
        if (span) cur = parseInt(span.textContent, 10) || 0;
      }
      body += '&quantity=' + Math.max(0, cur + parseInt(how, 10));
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- product page ---------- */
  var variantData = null;
  var vdEl = $('variantData');
  if (vdEl) {
    try { variantData = JSON.parse(vdEl.textContent); } catch (e) { variantData = null; }
  }

  function selectedOptions() {
    var out = [];
    document.querySelectorAll('.sizes[data-option-index]').forEach(function (wrap) {
      var on = wrap.querySelector('button.on');
      out.push(on ? on.getAttribute('data-value') : null);
    });
    return out;
  }

  function findVariant() {
    if (!variantData) return null;
    var sel = selectedOptions();
    for (var i = 0; i < variantData.length; i++) {
      var v = variantData[i], ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] && v['option' + (j + 1)] !== sel[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function refreshVariantUI() {
    var v = findVariant();
    var idInput = $('variantId'), price = $('pPrice'), btn = $('addBtn');
    if (!v) return;
    if (idInput) idInput.value = v.id;
    if (price) price.textContent = money(v.price);
    if (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    document.querySelectorAll('.sizes[data-option-index]').forEach(function (wrap, idx) {
      wrap.querySelectorAll('button').forEach(function (b) {
        var val = b.getAttribute('data-value');
        var possible = variantData.some(function (vv) {
          if (!vv.available) return false;
          for (var j = 0; j < idx; j++) {
            var sel = selectedOptions()[j];
            if (sel && vv['option' + (j + 1)] !== sel) return false;
          }
          return vv['option' + (idx + 1)] === val;
        });
        b.classList.toggle('unavailable', !possible);
      });
    });
  }

  document.querySelectorAll('.sizes[data-option-index] button').forEach(function (b) {
    b.addEventListener('click', function () {
      var wrap = b.closest('.sizes');
      wrap.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      refreshVariantUI();
    });
  });

  // preselect first available variant's options
  if (variantData && variantData.length) {
    var first = variantData.find(function (v) { return v.available; }) || variantData[0];
    document.querySelectorAll('.sizes[data-option-index]').forEach(function (wrap, idx) {
      var val = first['option' + (idx + 1)];
      wrap.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-value') === val);
      });
    });
    refreshVariantUI();
  }

  // thumbnails
  var thumbs = $('pThumbs'), mainImg = $('pMainImg');
  if (thumbs && mainImg) {
    thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        mainImg.src = b.getAttribute('data-src');
      });
    });
  }

  // qty
  var qty = 1;
  on('qtyMinus', 'click', function () { qty = Math.max(1, qty - 1); $('qtyN').textContent = qty; $('qtyInput').value = qty; });
  on('qtyPlus', 'click', function () { qty = Math.min(99, qty + 1); $('qtyN').textContent = qty; $('qtyInput').value = qty; });

  // AJAX add to cart
  var form = $('product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); toast('Added to cart'); })
        .catch(function () { form.submit(); });
    });
  }

  /* ---------- tabs (fighter storefront) ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('button[data-tab]');
    var panes = tabs.parentNode.querySelectorAll('.tabpane');
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        buttons.forEach(function (x) { x.classList.remove('on'); });
        panes.forEach(function (p) { p.classList.remove('on'); });
        b.classList.add('on');
        var pane = document.getElementById('tab-' + b.getAttribute('data-tab'));
        if (pane) pane.classList.add('on');
      });
    });
  });

  /* ---------- initial cart render ---------- */
  refreshCart();
})();
